export default __webpack_public_path__ + "static/media/Front-Horizan-Residential-Compound.f511db69.jpg";